import { render, staticRenderFns } from "./makePageFormModel.vue?vue&type=template&id=4b722715&scoped=true"
import script from "./makePageFormModel.vue?vue&type=script&lang=js"
export * from "./makePageFormModel.vue?vue&type=script&lang=js"
import style0 from "./makePageFormModel.vue?vue&type=style&index=0&id=4b722715&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b722715",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b722715')) {
      api.createRecord('4b722715', component.options)
    } else {
      api.reload('4b722715', component.options)
    }
    module.hot.accept("./makePageFormModel.vue?vue&type=template&id=4b722715&scoped=true", function () {
      api.rerender('4b722715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/settings/components/makePageFormModel.vue"
export default component.exports